import { getSettings } from './settings';
export function getComponents() {
    return getSettings().components ?? {};
}
export function resolveComponentClasses(theme) {
    return typeof theme === 'string' ? { root: theme } : theme ?? {};
}
export function getComponentClasses(name) {
    const settings = getSettings();
    return resolveComponentClasses(settings?.components?.[name]?.classes);
}
